import * as React from 'react';

import type {MeetingType} from 'nutshell-graphql-types';
import type {MeetingFragment as Meeting} from 'nutshell-graphql-types';

import {MeetingCohostSelect} from './meeting-cohost-select';
import {MeetingHostTypeSelection} from './meeting-host-type-selection';
import type {CohostUserOption} from './use-get-cohost-user-options';

type Props = {
    existingMeeting: Meeting | null | undefined;
    cohostUserOptions: CohostUserOption[] | null | undefined;
    selectedCohostIds: string[];
    setSelectedCohostIds: (userIds: string[]) => void;
    selectedTeamId: string | null | undefined;
    setSelectedTeamId: (teamId?: string | null | undefined) => void;
    selectedHostType: MeetingType;
    setSelectedHostType: (hostType: MeetingType) => void;
    hasFullSchedulerAccess?: boolean;
    isAdmin?: boolean;
    onSearchChange: (search: string) => void;
};

export function CreateMeetingModalContent(props: Props) {
    return props.existingMeeting ? (
        <MeetingCohostSelect
            cohostUserOptions={props.cohostUserOptions}
            selectedCohostIds={props.selectedCohostIds}
            setSelectedCohostIds={props.setSelectedCohostIds}
            isDuplicateMeeting={true}
            onSearchChange={props.onSearchChange}
        />
    ) : (
        <MeetingHostTypeSelection
            cohostUserOptions={props.cohostUserOptions}
            selectedHostType={props.selectedHostType}
            setSelectedHostType={props.setSelectedHostType}
            selectedCohostIds={props.selectedCohostIds}
            setSelectedCohostIds={props.setSelectedCohostIds}
            selectedTeamId={props.selectedTeamId}
            setSelectedTeamId={props.setSelectedTeamId}
            hasFullSchedulerAccess={props.hasFullSchedulerAccess}
            isAdmin={props.isAdmin}
            onSearchChange={props.onSearchChange}
        />
    );
}
